<template>
  <el-form
    ref="form"
    size="mini"
    label-position="right"
    label-width="150px"
    class="demo-form-inline"
    :model="examBasicQuery"
    :disabled="disabled"
  >
    <el-form-item label="饮食1小时及以上：" label-width="150px" >
      <el-switch v-model="examBasicQuery.dietAfterHour"></el-switch>
    </el-form-item>
    <el-form-item label="作息：">
      晚上
      <el-input v-model="examBasicQuery.sleepRange.sleep" class="small-input" />
      点睡觉，
      <el-input
        class="small-input"
        v-model="examBasicQuery.sleepRange.getup"
      />点起床， 合计
      <el-input
        class="small-input"
        v-model="examBasicQuery.sleepRange.total"
      />小时
    </el-form-item>
    <el-form-item label="熬夜：">
      <el-radio-group v-model="examBasicQuery.stayUp" :min="0">
        <el-radio label="从不"></el-radio>
        <el-radio label="偶尔"></el-radio>
        <el-radio label="经常"></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="睡眠质量：" prop="sleepProblem">
      <el-checkbox-group v-model="examBasicQuery.sleepProblem" :min="0">
        <el-checkbox label="良好"></el-checkbox>
        <el-checkbox label="一般"></el-checkbox>
        <el-checkbox label="入睡难"></el-checkbox>
        <el-checkbox label="易醒"></el-checkbox>
        <el-checkbox label="多梦"></el-checkbox>
        <el-checkbox label="起夜"></el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="饮食：">
      <el-radio-group v-model="examBasicQuery.dietaryFavor" :min="0">
        <el-radio label="清淡"></el-radio>
        <el-radio label="一般"></el-radio>
        <el-radio label="重油重盐"></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="月经（女性）：">
      <el-radio-group v-model="examBasicQuery.menstruation" :min="0">
        <el-radio label="绝经"></el-radio>
        <el-radio label="量多"></el-radio>
        <el-radio label="正常"></el-radio>
        <el-radio label="量少"></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="饮酒：">
      <el-radio-group v-model="examBasicQuery.drinking.choice" @change="drinkingFreqChange">
        <el-radio label="从不"></el-radio>
        <el-radio label="偶尔"></el-radio>
        <el-radio label="经常"></el-radio>
      </el-radio-group>
      <span style="margin-left: 20px">
        <el-input
          class="small-input"
          v-model="examBasicQuery.drinking.year"
        />年， 每周
        <el-input
          v-model="examBasicQuery.drinking.frequency"
          class="small-input"
        />次
        <el-input
          v-model="examBasicQuery.drinking.volume"
          class="small-input"
        /> ml
      </span>
    </el-form-item>
    <el-form-item label="饮酒类型：">
      <el-checkbox-group
        v-model="examBasicQuery.drinking.types"
        :disabled="examBasicQuery.drinking.choice=='从不'"
      >
        <el-checkbox label="啤酒"></el-checkbox>
        <el-checkbox label="红酒"></el-checkbox>
        <el-checkbox label="白酒"></el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="抽烟史：">
      <span>
        <el-radio-group v-model="examBasicQuery.smoking.choice">
          <el-radio label="从不"></el-radio>
          <el-radio label="偶尔"></el-radio>
          <el-radio label="经常"></el-radio>
          <el-radio label="戒烟"></el-radio>
        </el-radio-group>
      </span>
      <span style="margin-left: 20px">
        吸烟<el-input
          class="small-input"
          v-model="examBasicQuery.smoking.year"
        />年，
        <el-input
          v-model="examBasicQuery.smoking.frequency"
          class="small-input"
        />支/日，补充： <el-input
          v-model="examBasicQuery.smoking.memo"
          class="large-input"
        />
        </span>
    </el-form-item>
    <el-form-item label="运动：">
      <el-switch v-model="examBasicQuery.sport.hasSport"></el-switch>
    </el-form-item>
    <el-form-item label="运动方式：">
      <el-checkbox-group
        v-model="examBasicQuery.sport.types"
        :disabled="!examBasicQuery.sport.hasSport"
      >
        <el-checkbox label="快走"></el-checkbox>
        <el-checkbox label="跑步"></el-checkbox>
        <el-checkbox label="足球"></el-checkbox>
        <el-checkbox label="爬山"></el-checkbox>
        <el-checkbox label="跳绳"></el-checkbox>
        <el-checkbox label="游泳"></el-checkbox>
        <el-checkbox label="羽毛球"></el-checkbox>
        <el-checkbox label="太极"></el-checkbox>
        <el-checkbox label="站桩"></el-checkbox>
        <el-checkbox label="马拉松"></el-checkbox>
        <el-checkbox label="其他"></el-checkbox>
      </el-checkbox-group>
    </el-form-item>

    <el-form-item label="近期精神：">
      <el-checkbox-group v-model="examBasicQuery.currentSpirit">
        <el-checkbox label="安逸舒适"></el-checkbox>
        <el-checkbox label="平常"></el-checkbox>
        <el-checkbox label="反应淡漠"></el-checkbox>
        <el-checkbox label="健忘/注意力不集中"></el-checkbox>
        <el-checkbox label="退缩回避"></el-checkbox>
        <el-checkbox label="焦虑紧张"></el-checkbox>
        <el-checkbox label="烦躁易怒"></el-checkbox>
        <el-checkbox label="抑郁"></el-checkbox>
        <el-checkbox label="困乏/疲倦"></el-checkbox>
        <el-checkbox label="休息不佳"></el-checkbox>
        <el-checkbox label="压力大"></el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="性格：">
      <el-radio-group v-model="examBasicQuery.personalityType">
        <el-radio label="A型性格"></el-radio>
        <el-radio label="B型性格"></el-radio>
        <el-radio label="C型性格"></el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item >
      <el-alert v-if="examBasicQuery.personalityType =='A型性格'"
        title="A型性格"
        type="info"
        :description="Personalities.A"
        show-icon>
      </el-alert>
      <el-alert v-else-if="examBasicQuery.personalityType =='B型性格'"
        title="B型性格"
        type="info"
        :description="Personalities.B"
        show-icon>
      </el-alert>
      <el-alert v-else-if="examBasicQuery.personalityType =='C型性格'"
        title="C型性格"
        type="info"
        :description="Personalities.C"
        show-icon>
      </el-alert>
      <el-alert v-else
        title="请选择性格类型"
        type="info"
        show-icon>
      </el-alert>
    </el-form-item>

    <el-form-item label="主要症状：">
      <el-radio-group v-model="examBasicQuery.mainSymptomFrequency.place" :min="0">
        <el-radio label="无"></el-radio>
        <el-radio label="胸闷"></el-radio>
        <el-radio label="胸疼"></el-radio>
        <el-radio label="肋痛"></el-radio>

        <el-radio label="腰背痛"></el-radio>
        <el-radio label="左肩放射痛"></el-radio>
        <el-radio label="胃脘部痛/胀满"></el-radio>

        <el-radio label="腹痛"></el-radio>
        <el-radio label="头痛"></el-radio>
        <el-radio label="头晕"></el-radio>

        <el-radio label="心慌/心悸"></el-radio>
        <el-radio label="牙痛"></el-radio>
        <el-radio label="膝盖痛"></el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="频次：">
      <el-radio-group v-model="examBasicQuery.mainSymptomFrequency.frequence"
      :disabled="examBasicQuery.mainSymptomFrequency.place=='无'">
        <el-radio label="经常（3-5天有症状/周）"></el-radio>
        <el-radio label="偶尔（2-5次/周或数次/年）"></el-radio>
        <el-radio label="极少数（以前或者现在出现1-2次）"></el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="既往症状：">
      <el-radio-group v-model="examBasicQuery.pastSymptomFrePlace.place">
        <el-radio label="无"></el-radio>
        <el-radio label="胸闷"></el-radio>
        <el-radio label="胸疼"></el-radio>
        <el-radio label="肋痛"></el-radio>
        <el-radio label="腰背痛"></el-radio>
        <el-radio label="左肩放射痛"></el-radio>
        <el-radio label="胃脘部痛/胀满"></el-radio>
        <el-radio label="腹痛"></el-radio>
        <el-radio label="头痛"></el-radio>
        <el-radio label="头晕"></el-radio>
        <el-radio label="心慌/心悸"></el-radio>
        <el-radio label="牙痛"></el-radio>
        <el-radio label="膝盖痛"></el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="频次：">
      <el-radio-group v-model="examBasicQuery.pastSymptomFrePlace.frequence"
      :disabled="examBasicQuery.pastSymptomFrePlace.place=='无'">
        <el-radio label="经常（3-5天有症状/周）"></el-radio>
        <el-radio label="偶尔（2-5次/周或数次/年）"></el-radio>
        <el-radio label="极少数（以前或者现在出现1-2次）"></el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="病位：">
      <el-radio-group v-model="examBasicQuery.pastSymptomFrePlace.organ">
        <el-radio label="无"></el-radio>
        <el-radio label="心脏"></el-radio>
        <el-radio label="小肠"></el-radio>
        <el-radio label="肝"></el-radio>
        <el-radio label="胆"></el-radio>
        <el-radio label="胃"></el-radio>
        <el-radio label="肺"></el-radio>
        <el-radio label="大肠"></el-radio>
        <el-radio label="肾"></el-radio>
        <el-radio label="膀胱"></el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item>
      <el-button
        :loading= "submitting"
        type="primary"
        @click="_updateExamBasicQuery"
        class="fullWidth"
        size="medium"
        v-show="!disabled"
        >保存</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { 
  ExamStatesValue, 
  Personalities 
  } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";
import {
  getExamBasicQuery,
  updateExamBasicQuery,
  updateExamState,
} from "../../api/userExamService";

export default {
  name: "BasicQuery",
  props: {
    examUuid: String,
    disabled: Boolean,
  },
  data() {
    return {
      submitting: false,
      Personalities,
      //基础问询-前端格式
      examBasicQuery: {
        examUuid: "",
        dietAfterHour: true,
        stayUp:"",
        dietaryFavor: "",
        menstruation: "",
        sleepRange: { 
          sleep: "",
          getup: "",
          total: "",
        },
        sleepProblem: [],
        drinking: {
          choice: "从不",
          year: "",
          frequency: "",
          types:[],
        },
        smoking: {
          choice: "从不",
          year: "",
          frequency: "",
        },
        sport: {
          hasSport: false,
          types: [],
        },
        currentSpirit: [],
        personalityType: "",
        mainSymptomFrequency: {
          place: "",
          frequence: ""
        },
        pastSymptomFrePlace: {
          place: "",
          frequence: "",
          organ:""
        }
      },
      //基础问询-后端格式
      model: {
        examUuid: "",
        dietAfterHour: true,
        stayUp:"",
        dietaryFavor: "",
        menstruation: "",
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
        mainSymptomFrequency: "",
        pastSymptomFrePlace: ""
      },
      rules: {
        sleepProblem: [
          { required: true, message: "请输入实际最大心率", trigger: "blur" }
        ],
      }
    };

  },
  methods: {
    drinkingFreqChange( value ){
      if(value == "从不"){
        this.examBasicQuery.drinking.types =[];
      }
    },
    //获取基础问询
    _getExamBasicQuery() {
      getExamBasicQuery(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data[0]) {
            this.model = res.data[0];
            //将数据转化为合适的格式后，赋值给examBasicQuery (这是前端展示的格式)
            this.examBasicQuery = this.getConvertor(res.data[0]);
          }
        } else {
          this.$message({ message: res.description, type: "error" });
        }
        // console.log("examBasicQuery", this.examBasicQuery);
      });
    },
    //更新基础问询
    _updateExamBasicQuery() {
      this.model = this.postDataConvertor(this.examBasicQuery);

      this.submitting= true;
      updateExamBasicQuery(this.model)
      .then(
        (res) => {
          this.submitting= false;
          if (res.success) {
            this.$message({ message: res.description, type: "success"});
            //更新检查状态后，重新获取检查信息
            this._updateExamState( ExamStatesValue.BASIC_QUERY_30, this._getExamBasicQuery );
          } else {
            this.$message({
              message: res.description,
              type: "warning",
            });
          }
        }
      ).catch (e => {
        this.submitting= false;
        console.log(e)
      });
    },
    //更新检查状态、并重新获取更新的信息
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    // data with typeof prop's value is string with splitter convert to Array
    getConvertor(data, direction, splitter = "^") {
      let convertedData = {
        examUuid: "",
        dietAfterHour: true,
        dietaryFavor:"",
        stayUp: "",
        menstruation: "",
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
        mainSymptomFrequency: "",
        pastSymptomFrePlace: ""
      };
      if (typeof data == "object") {
        for (let key in data) {
          let temp;
          switch (key) {
            case "examUuid":
              convertedData[key] = data[key];
              break;
            case "dietAfterHour":
              convertedData[key] = JSON.parse(data[key]);
              break;
            case "stayUp":
              convertedData[key] = data[key];
              break;
            case "menstruation":
              convertedData[key] = data[key];
              break;
            case "dietaryFavor":
              convertedData[key] = data[key];
              break;
            case "sleepRange":
              temp = data[key].split(splitter);
              convertedData[key] = {
                sleep: temp[0],
                getup: temp[1],
                total: temp[2],
              };
              break;
            case "sleepProblem":
              convertedData[key] = data[key].split(splitter);
              break;
            case "drinking":
              temp = data[key].split(splitter);
              if(temp.length <= 4){ // old msg type
                convertedData[key] = {
                  choice: temp[0],
                  year: temp[1],
                  frequency: temp[2],
                  volume: ""
                };
                
                if(temp.length >3 ){
                  convertedData[key].types = temp[3].split(',').filter(function(el) {
                    return el != "";
                  });
                }
                //考虑以前的数据 没有 饮酒类型时，将type设置为[]'
                else{
                  convertedData[key].types = [];
                }
                console.log('drinking-types',convertedData[key].types)
              }else {
                convertedData[key] = {
                    choice: temp[0],
                    year: temp[1],
                    frequency: temp[2],
                    volume: temp[3]
                };
                convertedData[key].types = temp[4].split(',').filter(function(el) {
                  return el != "";
                });
              }
              break;
            case "smoking":
              if(!data[key]) break;
              temp = data[key].split(splitter);
              convertedData[key] = {
                choice: temp[0],
                year: temp[1],
                frequency: temp[2],
                memo: temp[3]?temp[3]:""
              };
              break;
            case "sport":
              temp = data[key].split(splitter);
              if (temp.length >= 1 && temp[0] != "") {
                convertedData[key] = {
                  hasSport: true,
                  types: temp,
                };
              } else {
                convertedData[key] = {
                  hasSport: false,
                  types: [],
                };
              }
              break;
            case "currentSpirit":
              if(!data[key]) {
                convertedData[key] = [];
                break;
              }
              temp = data[key].split(splitter);
              convertedData[key] = temp;
              break;
            case "personalityType":
              convertedData[key] = data[key];
              break;
            case "mostBother":
              convertedData[key] = data[key];
              break;
            case "mainSymptomFrequency":
              if (!data[key]) {
                  convertedData[key] = {
                  place: "无",
                  frequence: "极少数（以前或者现在出现1-2次）"
                };
                break;
              }
              temp = data[key].split(splitter);
              convertedData[key] = {
                place: temp[0],
                frequence: temp[1]
              };
              break;
            case "pastSymptomFrePlace":
            if (!data[key]) {
                  convertedData[key] = {
                  place: "无"
                };
                break;
            }
              temp = data[key].split(splitter);
              convertedData[key] = {
                place: temp[0],
                frequence: temp[1],
                organ: temp[2]
              };
              break;
          }
        }
        return convertedData;
      } else {
        alert("转换器不能转换非对象");
        return false;
      }
    },
    // data with typeof prop's value is Array convert to string with splitter
    postDataConvertor(data, splitter = "^") {
      let convertedData = {
        examUuid: "",
        dietAfterHour: true,
        dietaryFavor:"",
        stayUp: "",
        menstruation: "",
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
        pastSymptomFrePlace: "",
        mainSymptomFrequency: ""
      };
      if (typeof data == "object") {
        for (let key in data) {
          switch (key) {
            case "examUuid":
              convertedData[key] = data[key];
              break;
            case "dietAfterHour":
              convertedData[key] = data[key];
              break;
            case "stayUp":
              convertedData[key] = data[key];
              break;
            case "menstruation":
              convertedData[key] = data[key];
              break;
            case "dietaryFavor":
              convertedData[key] = data[key];
              break;
            case "sleepRange":
              convertedData[key] =
                data[key].sleep +
                splitter +
                data[key].getup +
                splitter +
                data[key].total;
              break;
            case "sleepProblem":
              convertedData[key] = data[key].join(splitter);
              break;
            case "drinking":
              convertedData[key] =
                data[key].choice +
                splitter +
                data[key].year +
                splitter +
                data[key].frequency +
                splitter +
                data[key].volume +
                splitter +
                data[key].types.join(",");
              break;
            case "smoking":
              convertedData[key] =data[key].choice +splitter +data[key].year + splitter + data[key].frequency  + splitter + data[key].memo;
              break;
            case "sport":
              if (data[key].hasSport) {
                convertedData[key] = data[key].types.join(splitter);
              } else {
                convertedData[key] = "";
              }
              break;
            case "currentSpirit":
              convertedData[key] = data[key].join(splitter);
              break;
            case "personalityType":
              convertedData[key] = data[key];
              break;
            case "mostBother":
              convertedData[key] = data[key];
              break;
            case "mainSymptomFrequency":
              convertedData[key] = data[key].place + splitter + data[key].frequence;
              break;
            case "pastSymptomFrePlace":
              convertedData[key] = data[key].place + splitter + data[key].frequence + splitter + data[key].organ;
              break;
          }
        }
        return convertedData;
      } else {
        alert("转换器不能转换非对象");
        return false;
      }
    },
    // test two Object is Indentical: (props are basic data types)
    ObectIdenticalTest(obj1, obj2) {
      let flag = true;
      for (let key in obj1) {
        // if(obj1[key] )
        if (obj1[key] != obj2[key]) {
          flag = false;
          return flag;
        }
      }
      for (let key in obj2) {
        if (obj2[key] != obj1[key]) {
          flag = false;
          return flag;
        }
      }
      return flag;
    },

  },
  created() {
    this.examBasicQuery.examUuid = this.examUuid;
    this.model.examUuid = this.examUuid;
    this._getExamBasicQuery();
  },
};
</script>

<style scoped>
.small-input {
  width: 70px;
}
.large-input {
  width: 140px;
}
.fullWidth {
  width: 100%;
}

.fr {
  float: right;
}
.fl {
  float: left;
}
</style>
